const navSlide = () => {
    const burgher = document.getElementById('burgher');
    const toggleBox = document.getElementById('toggle-box');
    const body = document.getElementsByTagName("body");

    if (burgher) {
        burgher.addEventListener('click', () => {
            body[0].classList.add("!overflow-hidden");
        });
    }
    if (toggleBox) {
        toggleBox.addEventListener('click', () => {
            body[0].classList.remove("!overflow-hidden");
        });
    }
    
};
const addTransitionsEffects = () => {
    const menuDropdowns = document.querySelectorAll('.expandable');
    const navBox = document.querySelector('.nav-box');
    if (navBox) {
        navBox.classList.add('transition-all');
        navBox.classList.add('duration-500');
    }
    menuDropdowns.forEach((el) => {
        el.classList.add('transition-transform');
        el.classList.add('duration-500');
        el.classList.add('delay-300');
    });
};

setTimeout(addTransitionsEffects, 500);
document.addEventListener("DOMContentLoaded", navSlide);
